import { useState } from "react";
import { toast } from "sonner";
import { sendContact, errorText } from "@/lib/api";

const EMPTY = { name: "", email: "", organisation: "", message: "" };
const FIELDS = [
  ["name", "Name", "text", true],
  ["email", "Email", "email", true],
  ["organisation", "Organisation", "text", false],
];

export const Contact = () => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await sendContact(form);
      setForm(EMPTY);
      toast.success("Message sent. Zarya's team will be in touch.");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section id="contact" className="bg-marigold text-ink py-24 md:py-32" data-testid="contact-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12">
        <div className="min-w-0 fr-reveal">
          <h2 className="font-mono font-bold fr-h2">Publishers, press, event hosts.</h2>
          <p className="mt-6 text-[17px] leading-[1.6] max-w-[48ch]">For rights, interviews, talks and events, send a note and it will reach Zarya directly.</p>
          <svg viewBox="0 0 240 120" className="w-full max-w-xs mt-12" aria-hidden="true">
            <path pathLength="1" className="fr-draw" d="M10 100L60 20L110 100L160 20L230 100" stroke="#1b1408" strokeWidth="4" fill="none" />
          </svg>
        </div>
        <form onSubmit={onSubmit} className="min-w-0 grid gap-4" data-testid="contact-form">
          {FIELDS.map(([k, label, type, req]) => (
            <label key={k} className="font-mono fr-lbl">
              {label}
              <input type={type} required={req} value={form[k]} onChange={set(k)} className="fr-field bg-sand" data-testid={`contact-${k}-input`} />
            </label>
          ))}
          <label className="font-mono fr-lbl">
            Message
            <textarea rows={4} required value={form.message} onChange={set("message")} className="fr-field bg-sand" data-testid="contact-message-input" />
          </label>
          <button type="submit" disabled={busy} className="fr-btn py-4" data-testid="contact-submit-button">
            {busy ? "Sending…" : "Send message"}
          </button>
        </form>
      </div>
    </section>
  );
};
